export default function MySQL_WILDCARDS() {
  return (
    <div>
      <h2>MySQL_WILDCARDS</h2>    </div>
  );
}